import { DataTableTypename } from "shared/types/DataTable"
import {
  DataTable,
  DimensioningOption,
  DimensioningPhysicalData,
  ProductConfigurationResponse
} from "shared/types/__generated__/graphql"

import { RestLink } from "apollo-link-rest"

export function patchProductConfigurationResponse(
  res: ProductConfigurationResponse,
  outerType: string,
  patchDeeper: RestLink.FunctionalTypePatcher,
  context: RestLink.TypePatcherContext
): ProductConfigurationResponse {
  return {
    ...res,
    dimensioningOptions: patchDeeper(
      res.dimensioningOptions,
      "DimensioningOption",
      patchDeeper,
      context
    ),
    __typename: "ProductConfigurationResponse"
  }
}

export function patchDimensioningOption(
  option: DimensioningOption
): DimensioningOption {
  return {
    ...option,
    physicalData: option.physicalData?.map(data => {
      if (Object.hasOwn(data, "header") && (data as DataTable).header) {
        return { ...data, __typename: DataTableTypename }
      }
      return {
        ...data,
        __typename: "DimensioningParameter"
      }
    }) as DimensioningPhysicalData[]
  }
}
